import { render, staticRenderFns } from "./newProductAddTime2Remark.vue?vue&type=template&id=72a3254e&scoped=true&"
import script from "./newProductAddTime2Remark.vue?vue&type=script&lang=js&"
export * from "./newProductAddTime2Remark.vue?vue&type=script&lang=js&"
import style0 from "./newProductAddTime2Remark.vue?vue&type=style&index=0&id=72a3254e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a3254e",
  null
  
)

export default component.exports